export default __webpack_public_path__ + "static/media/rythm_fr.264c5ed3.png";